import React from 'react'
import { Row, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { IntegrationProjects } from 'src/core/models'
import { CustomCol, CustomTitle } from 'src/components'
import styles from './PreviewPurchasesListHeader.module.scss'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { offsetByExcelSelector, setSelectedProjectForPurchase, setSelectedVintagetForPurchase } from 'src/features'

interface PreviewPurchasesListHeaderProps {
  length: number
  integrationProjects: IntegrationProjects[]
}

const PreviewPurchasesListHeader: React.FC<PreviewPurchasesListHeaderProps> = ({ length, integrationProjects }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const {
    offsetKeys: { co2UnitField }, preparePurchases: { selectedProjectId, selectedVintageYear }
  } = useAppSelector(offsetByExcelSelector)
  const { width } = useWindowSize()
  const isMobile = width <= 800

  const handleProjectChange = (value: string) => {
    const [project_id, year]= value.split('-')
    dispatch(setSelectedProjectForPurchase(+project_id))
    dispatch(setSelectedVintagetForPurchase(+year))
  }

  const getAvailableCredits = (credits: number): string => {
    const value = co2UnitField === 'KG' ? (credits * 1000)?.toFixed(3) : credits?.toFixed(3)
    return co2UnitField === 'KG' ? `${value} kgCO2` : `${value} tCO2`
  }

  return (
    <Row>
      <CustomCol>
        <CustomTitle label={<>{t('developers.OffSet.PreviewExcel')} (<strong>{length}</strong>)</>} />
      </CustomCol>
      <CustomCol className={isMobile && 'mt-3'}>
        <Select
          size='large'
          value={!selectedProjectId?null:selectedProjectId+'-'+selectedVintageYear}
          className={styles.selector}
          onChange={handleProjectChange}
          placeholder={t('developers.OffSet.ProjectsPlaceholder')}
        >
          {integrationProjects?.map((item: IntegrationProjects) => (
            item.vintage_items?.length>0 ?
              <Select.OptGroup key={item?.id+'-'+item?.name} label={item.name}>
                {item.vintage_items.map(v=>(
                  <Select.Option value={item?.id+'-'+v.year} key={item?.id+'-'+v.year}>
             ({getAvailableCredits(v?.available_volume_credits)}) - <strong>{v.year} - {item.name}</strong>
                  </Select.Option>
                ))}
              </Select.OptGroup>
              :<Select.Option value={item?.id+'-0'} key={item?.id}>
              ({getAvailableCredits(item?.available_volume_credits)}) - <strong>{item?.name}</strong>
              </Select.Option>
          ))}
        </Select>
      </CustomCol>
    </Row>
  )
}

export default PreviewPurchasesListHeader
